import { atom } from "recoil";

export const collapsedState = atom({
  key: "collapsedState",
  default: true,
});
